import { initializeApp } from "@firebase/app";
import React, { useEffect, useState } from "react";
import {
	query,
	onSnapshot,
	collection,
	getFirestore,
} from "@firebase/firestore";
import { firebaseConfig } from "../../../config/firebaseConfig";
import "../../styles/TimeManagement.css";
import NavbarBpw2 from "../../generalComponents/NavbarBpw2";
import NavbarBpw3 from "../../generalComponents/NavbarBpw3";
import NavbarBpw4 from "../../generalComponents/NavbarBpw4";
import Message from "../../generalComponents/Message";
import Loader from "../../generalComponents/Loader";
import { TimeManagementInitial } from "./timeManagementInitial";
import TimePermisionsApp from "./timePermisions/timePermisionsApp";
import { TimeClocksApp } from "./timeClocks/timeClocksApp";

export const TimeManagementApp = () => {
	const app = initializeApp(firebaseConfig);
	const db = getFirestore(app);

	const [dataBase, setDataBase] = useState(null); //listado del inventario el almacén General de la empresa
	const [error, setError] = useState(null);
	const [loading, setLoading] = useState(false);
	const [permitedClock, setPermitedClock] = useState(false);
	const [permitedReports, setPermitedReports] = useState(false);
	const [permitedDataBases, setPermitedDataBases] = useState(false);
	const [option, setOption] = useState(null);

	const company = localStorage.getItem("usuariosEmpresa");
	const jsonValue = localStorage.getItem("userLocal");
	const localUser = JSON.parse(jsonValue);

	const askPermisions = () => {
		setLoading(true);
		const collectionName = "timePermisions-" + company;

		const q = query(collection(db, collectionName));
		onSnapshot(q, (querySnapshot) => {
			const dataList = [];
			querySnapshot.forEach((doc) => {
				dataList.push(doc.data());
			});
			const email = localUser.email;
			try {
				let clockPermisions = dataList.filter(
					(item) => item.typePermision == "Clock"
				)[0].timeClockPermision;
				if (clockPermisions.includes(email)) {
					setPermitedClock(true);
				} else {
					setPermitedClock(false);
				}
			} catch (error) {}

			try {
				let reportsPermisions = dataList.filter(
					(item) => item.typePermision == "Reports"
				)[0].timeReportsPermision;
				if (reportsPermisions.includes(email)) {
					setPermitedReports(true);
				} else {
					setPermitedReports(false);
				}
			} catch (error) {}

			try {
				let dataBasesPermisions = dataList.filter(
					(item) => item.typePermision == "DataBases"
				)[0].timeDataBasesPermision;
				if (dataBasesPermisions.includes(email)) {
					setPermitedDataBases(true);
				} else {
					setPermitedDataBases(false);
				}
			} catch (error) {}
			setLoading(false);
		});
	};

	useEffect(() => {
		askPermisions();
	}, []);

	const changeButton = (option) => {
		setOption(option);
	};

	return (
		<div>
			{localUser.type === "2" ? (
				<NavbarBpw2 />
			) : localUser.type === "3" ? (
				<NavbarBpw3 />
			) : (
				localUser.type === "4" && <NavbarBpw4 />
			)}

			<article>
				{loading ? (
					<Loader />
				) : (
					<div>
						{error && <Message mensaje={error} bgColor="#dc3545" />}

						<div>
							<div className="containerTime01">
								<div className="containerTime02">
									{permitedClock && (
										<div>
											{option === "Relojes" ? (
												<button
													className="buttonTime03"
													onClick={() => changeButton("Relojes")}
												>
													Relojes
												</button>
											) : (
												<button
													className="buttonTime02"
													onClick={() => changeButton("Relojes")}
												>
													Relojes
												</button>
											)}
										</div>
									)}
									{permitedReports && (
										<div>
											{option === "Informes" ? (
												<button
													className="buttonTime03	"
													onClick={() => changeButton("Informes")}
												>
													Informes
												</button>
											) : (
												<button
													className="buttonTime02	"
													onClick={() => changeButton("Informes")}
												>
													Informes
												</button>
											)}
										</div>
									)}

									{permitedDataBases && (
										<div>
											{option === "Data Base" ? (
												<button
													className="buttonTime03	"
													onClick={() => changeButton("Data Base")}
												>
													Data Base
												</button>
											) : (
												<button
													className="buttonTime02	"
													onClick={() => changeButton("Data Base")}
												>
													Data Base
												</button>
											)}
										</div>
									)}

									{localUser.type === "2" && (
										<div>
											{option === "Permisos" ? (
												<button
													className="buttonTime03	"
													onClick={() => changeButton("Permisos")}
												>
													Permisos
												</button>
											) : (
												<button
													className="buttonTime02	"
													onClick={() => changeButton("Permisos")}
												>
													Permisos
												</button>
											)}
										</div>
									)}
								</div>

								<div className="containerTime03">
									{option === null && <TimeManagementInitial />}
									{option === "Relojes" && <TimeClocksApp />}
									{option === "Informes" && <TimeManagementInitial />}
									{option === "Data Base" && <TimeManagementInitial />}
									{option === "Permisos" && <TimePermisionsApp />}
								</div>
							</div>
						</div>
					</div>
				)}
			</article>
		</div>
	);
};
